import { HStack, Icon, IconName, IndicatorBadge, IndicatorBadgeVariants, Text } from '@talos/kyoko';

interface EnabledBadgeProps {
  enabled: boolean;
}

export function EnabledBadge({ enabled }: EnabledBadgeProps) {
  if (!enabled) {
    return (
      <Text size="fontSizeSmall" color="colorTextSubtle">
        Disabled
      </Text>
    );
  }

  return (
    <IndicatorBadge variant={IndicatorBadgeVariants.Primary}>
      <HStack gap="spacing4" alignItems="center">
        <Icon icon={IconName.Check} size={12} />
        <Text size="fontSizeTiny" color="colorTextPrimaryButton">
          Enabled
        </Text>
      </HStack>
    </IndicatorBadge>
  );
}
